export const CONTRACT_TYPE = {
    FIXED_PRICE: 'FIXED_PRICE',
    RETAINER: 'RETAINER',
    AMC: 'AMC',
    SUPPORT_HOURS: 'SUPPORT_HOURS',
    DEDICATED_DEV: 'DEDICATED_DEV',
};
export const CONTRACT_TYPE_LABELS = {
    FIXED_PRICE: 'Fixed price',
    RETAINER: 'Monthly retainer',
    AMC: 'Annual maintenance contract',
    SUPPORT_HOURS: 'Support hours',
    DEDICATED_DEV: 'Dedicated developer',
};
//# sourceMappingURL=contract-type.js.map